import { IOnePageInfo } from "@/types/types";
import React, { useState, useEffect } from "react";
import { useSmartNavigate } from "@/hooks";
import { Button, Result } from "antd";
import { getMenus, getLowcodePageInfo } from "@/services";
import {
  getEffectivePagePath,
  getSearchParams,
  findMenuTreeNode,
} from "@/utils";
import styles from "./index.module.css";

const FormResultPage = ({ onePageInfo }: { onePageInfo?: IOnePageInfo }) => {
  const navigate = useSmartNavigate(onePageInfo);
  // 获取有效的低码页面path, 优先从onePageInfo中取
  const path = onePageInfo?.innerPagePath
    ? onePageInfo.innerPagePath
    : getEffectivePagePath();
  // 从url参数中取数据dataid, 优先从onePageInfo中取
  const dataid =
    onePageInfo?.innerSearchParams?.dataid || getSearchParams("dataid");
  const [ftpPageInfo, setFtpPageInfo] = useState(null);

  /**
   * path变化时说明发生了页面切换, 需要重新获取页面信息
   */
  useEffect(() => {
    const getLowcodePageSchema = async () => {
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息
      if (node && node.pageId) {
        // 1. 取当前CREATE页面关联的页面信息
        const pageInfo = await getLowcodePageInfo(node.pageId);
        // 2. 找到ftp页id, TODO: 暂时保持现状, 取第一个, 后续需要考虑指定datasetId
        const ftpPage = pageInfo.relatedPageInfoList?.[0]?.pageInfo.find(
          (item) => item.type === "FTP",
        );
        // 2. setState
        setFtpPageInfo(ftpPage);
      }
    };
    getLowcodePageSchema();
  }, [path]);

  return (
    <div className={styles.container}>
      <Result
        status="success"
        title="提交成功"
        subTitle=""
        extra={
          <>
            <Button
              type="primary"
              disabled={!dataid}
              onClick={() => navigate(`../detail?dataid=${dataid}`)}
            >
              查看
            </Button>
            <Button
              disabled={!dataid}
              onClick={() => navigate(`../update?dataid=${dataid}`)}
            >
              修改
            </Button>
            <Button onClick={() => navigate(path)}>继续提交</Button>
            <Button
              disabled={!ftpPageInfo?.code}
              onClick={() => {
                const ftpPagePath =
                  (ftpPageInfo.code.startsWith("/") ? "" : "/") +
                  ftpPageInfo.code;
                navigate(ftpPagePath);
              }}
            >
              去管理页
            </Button>
          </>
        }
      />
    </div>
  );
};

export default FormResultPage;
